import "./ShowLegislation.css";

import { Breadcrumb, Button, message } from "antd";
import { BiEdit } from "react-icons/bi";
import { BsTrash } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";

import {
  deleteLegislation,
  type LinkList,
  useAppSelector,
} from "../../../_lib/_store";

export const ShowLegislationPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading } = useAppSelector((state) => state.legislation);

  const navigate = useNavigate();
  const { state } = useLocation();

  const legislationObj = state?.legislation;

  const handleDelete = async () => {
    const res = await deleteLegislation(messageApi, legislationObj?.id);
    if (res) {
      navigate("/legislation-link");
    }
  };

  return (
    <>
      {contextHolder}
      <div className="createCategory">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: <Link to="/legislation-link">Legislation Link</Link>,
            },
            {
              title: "Show",
            },
          ]}
        />

        <div className="titleHeader">
          <h2 className="title">Show</h2>
          <div className="actionButton">
            <Button
              icon={<BiEdit />}
              size="large"
              onClick={() =>
                navigate(`/legislation-link/edit`, {
                  state: { legislation: state?.legislation },
                })
              }
            >
              Edit
            </Button>
            <Button
              icon={<BsTrash />}
              size="large"
              onClick={handleDelete}
              loading={isLoading}
            >
              Delete
            </Button>
          </div>
        </div>

        <div className="form">
          <div className="row">
            <p className="label">Title</p>
            <p className="value">{legislationObj?.title}</p>
          </div>
          <div className="row">
            <p className="label">Id</p>
            <p className="value">{legislationObj?.id}</p>
          </div>
          <div className="row">
            <p className="label">Url</p>
            <p className="value">{legislationObj?.url}</p>
          </div>
          <div className="row">
            <p className="label">Description</p>
            <p className="value">{legislationObj?.description}</p>
          </div>
          <div className="row">
            <p className="label">Site Name</p>
            <p className="value">{legislationObj?.siteName}</p>
          </div>
          <div className="row">
            <p className="label">Metadata</p>
            <p className="value">
              {legislationObj?.metadata?.originalMetadata}
            </p>
          </div>
          <div className="row">
            <p className="label">Package Id</p>
            <p className="value">{legislationObj?.package?.name}</p>
          </div>
          <div className="row">
            <p className="label">Category Id</p>
            <p className="value">{legislationObj?.category?.name}</p>
          </div>
          <div className="row">
            <p className="label">Sub Category Id</p>
            <p className="value">{legislationObj?.subCategory?.name}</p>
          </div>
          <div className="row">
            <p className="label">Link List</p>
            <div className="linkSection">
              {legislationObj?.linkList?.map((v: LinkList, i: number) => {
                return (
                  <div key={i} className="linkBox">
                    <div className="row">
                      <p className="value">Link {i + 1}</p>
                    </div>
                    <div className="row">
                      <p className="label">URL</p>
                      <p className="value">{v?.url}</p>
                    </div>
                    <div className="row">
                      <p className="label">Title</p>
                      <p className="value">{v?.title}</p>
                    </div>
                    <div className="row">
                      <p className="label">Description</p>
                      <p className="value">{v?.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
